import React from 'react';
import * as Styled from './AdminFormWrap.style';
import { ACCOUNT_ADMIN_TAB_TITLE } from '../../../../../constants/service/app/accountAdminConstants';

interface IAdminFormWrapProps {
  children: React.ReactNode;
}

const AdminFormWrap = ({ children }: IAdminFormWrapProps): JSX.Element => {
  return (
    <Styled.Container>
      <Styled.Wrapper>
        <Styled.Header>
          <strong>{ACCOUNT_ADMIN_TAB_TITLE.ADMIN_INFO}</strong>
        </Styled.Header>
        <Styled.Section>{children}</Styled.Section>
      </Styled.Wrapper>
    </Styled.Container>
  );
};

export default AdminFormWrap;
